import bowser from "bowser";

import * as types from "../constants/ActionTypes";
import * as store from "../storage/localStorage";
import * as extensionConsts from "../constants/Extension";
import * as pluginVersionValidator from "../utils/PluginVersionValidator";

const getBrowserExtensionUrl = () => {
  if (bowser.msie) {
    return extensionConsts.IE_EXTENSION_DOWNLOAD_LINK;
  } else if (bowser.firefox) {
    return extensionConsts.FIREFOX_EXTENSION_DOWNLOAD_LINK;
  } else if (bowser.msedge) {
    return extensionConsts.EDGE_EXTENSION_DOWNLOAD_LINK;
  } else if (bowser.safari) {
    return extensionConsts.SAFARI_EXTENSION_DOWNLOAD_LINK;
  } else if (bowser.chrome) {
    return extensionConsts.CHROME_EXTENSION_DOWNLOAD_LINK;
  } else {
    return "";
  }
};

const initialState = {
  detected: store.getExtensionDetected(),
  installationSkipped: store.getExtensionInstallSkipped(),
  browserExtensionUrl: getBrowserExtensionUrl(),
  compatibleVersion: undefined,
  version: undefined,
  shouldExtensionBeInstalled: undefined,
  shouldExtensionBeUpgraded: undefined
};

function extension(state = initialState, action) {
  switch (action.type) {
    case types.EXTENSION_DETECTED:
      const isCompatible = pluginVersionValidator.compatibleVersion(
        action.version
      );
      return {
        ...state,
        detected: true,
        installationSkipped: false,
        version: action.version,
        compatibleVersion: isCompatible,
        shouldExtensionBeInstalled: false,
        shouldExtensionBeUpgraded: !isCompatible
      };
    case types.EXTENSION_NOT_DETECTED:
      return {
        ...state,
        detected: false,
        shouldExtensionBeInstalled: true
      };
    case types.EXTENSION_SKIP_INSTALL:
      return {
        ...state,
        installationSkipped: true,
        shouldExtensionBeInstalled: true
      };
    default:
      return state;
  }
}

export default extension;
